var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"test"},[_c('img',{staticClass:"image",attrs:{"src":require("@/assets/family/jingci/1.jpg"),"alt":""}}),_c('Sticky')],1)}
var staticRenderFns = []

export { render, staticRenderFns }